import React, { useState } from "react";
import { Modal, Button, Box, Grid } from "@mui/material";
import { H4, H5 } from "./Typography";

type MyModalProps = {
  open: boolean;
  handleClose: () => void;
  handleSave: (value: any,totalYears:any) => void;
  data?:any
};


function GoalYearModel({
  open,
  handleClose,
  handleSave,
  data,
}: MyModalProps) {
  const handleSaveClick = () => {
    let totalYears = slectedIndex+1;
    handleSave(selectedDate,totalYears);
    setDateColor("#000");
    setSelectedDate(date);
  };
  const handleCloseSaveClick = () => {
    handleClose();
  };
  
  const [datecolor, setDateColor] = React.useState("");
  const [date, setDate] = React.useState("");
  const [selectedDate, setSelectedDate] = useState("");

  const [slectedIndex, setSlectedIndex] = React.useState("");
  const handleDateClick = (date: any,index: any) => {
    setSelectedDate(date);
    setSlectedIndex(index)
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid sx={style}>
        <Box sx={header}>
          <H5
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              p: 1.5,
              color: "#ffff",
            }}
            fontWeight={"500"}
          >
            Year
          </H5>
        </Box>
        <Grid container sx={{ mt: 2,p:2 }} spacing={2}>
          {data.map((year: any, index: number) => (
            <Grid item key={index} xs={2}>
              <div
                style={{
                  backgroundColor:
                  year === selectedDate ?  process.env.REACT_APP_PRIMARY_COLOR : "#FEF7E3",
                  padding: "5px",
                  borderRadius: "8px",
                  textAlign: "center",
                  cursor: "pointer",
                 
                }}
                onClick={() => handleDateClick(year,index)}
              >
                  <H4 fontWeight={550} sx={{ color:  year === selectedDate ? "#fff" :"#000",  fontFamily: "'Poppins', sans-serif", }}>
                  {year}
            </H4>
              </div>
            </Grid>
          ))}
        </Grid>
        <Box sx={container}>
          {selectedDate ? (
            <H5 fontWeight={400} sx={{ color: "#595959",  fontFamily: "'Poppins', sans-serif", }}>
                { "Complete your Goal in "+ `${slectedIndex+1} Year` +" "  }
            </H5>
          ) : null}

          <Box sx={buttonContainer}>
            <Button variant="contained" onClick={handleCloseSaveClick} sx={close}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSaveClick} sx={add}>
              Submit
            </Button>
          </Box>
        </Box>
      </Grid>
    </Modal>
  );
}

export default GoalYearModel;
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    md:'30%',
   xs:'90%',
  },
  bgcolor: "background.paper",

  boxShadow: 4,

  borderRadius: 2,
  overflow: "hidden",
};
const header = {
  width: '100%',
  bgcolor: process.env.REACT_APP_PRIMARY_COLOR,

  boxShadow: 4,
};
const container = {
  pl: 2,
  pr: 2,
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  pb: 1.5,
  pt: 2,
};

const buttonContainer = {
  width: "90%",
  justifyContent: "center",
  flexDirection: "row",
  display: "flex",
  p: 1,
  mt: 1.5,
};

const add = {
  background:process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: {
    md: "80%",
    xs: "45%",
  },
  mb: 1,
  ml:2,
  borderRadius: 2,
};
const close = {
    background: "#fff",
    color: "#000",
    width: {
      md: "80%",
      xs: "45%",
    },
    mb: 1,
    mr:2,
    borderRadius: 2,
  };

